import { render, staticRenderFns } from "./TaxReturnTableRow.vue?vue&type=template&id=2336f09f&scoped=true&"
import script from "./TaxReturnTableRow.vue?vue&type=script&lang=js&"
export * from "./TaxReturnTableRow.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnTableRow.vue?vue&type=style&index=0&id=2336f09f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336f09f",
  null
  
)

export default component.exports